'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var allMethods = function allMethods(targetClass) {
  var propertys = Object.getOwnPropertyNames(Object.getPrototypeOf(targetClass));
  propertys.splice(propertys.indexOf('constructor'), 1);
  return propertys;
};

exports.default = function (targetClass) {
  var methodNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (!methodNames.length ? allMethods(targetClass) : methodNames)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var name = _step.value;

      targetClass[name] = targetClass[name].bind(targetClass);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

module.exports = exports['default'];